'use strict';

// src/tokens/themes/light/colors.ts
var colorBaseNeutral50 = "#f5f5f5";
var colorBaseNeutral75 = "#e8e8e8";
var colorBaseNeutral100 = "#dbdbdb";
var colorBaseNeutral200 = "#bfbfbf";
var colorBaseNeutral300 = "#a3a3a3";
var colorBaseNeutral400 = "#8c8c8c";
var colorBaseNeutral500 = "#707070";
var colorBaseNeutral600 = "#575757";
var colorBaseNeutral700 = "#3d3d3d";
var colorBaseNeutral800 = "#292929";
var colorBaseNeutral900 = "#1a1a1a";
var colorBaseNeutralWhite = "#ffffff";
var colorBaseNeutralBlack = "#000000";
var colorBaseBlue50 = "#ebfaff";
var colorBaseBlue75 = "#ccf2ff";
var colorBaseBlue100 = "#b3ebff";
var colorBaseBlue200 = "#86d8f9";
var colorBaseBlue300 = "#3ab5ee";
var colorBaseBlue400 = "#1495e6";
var colorBaseBlue500 = "#136fd8";
var colorBaseBlue600 = "#0b54a8";
var colorBaseBlue700 = "#0a3d71";
var colorBaseBlue800 = "#0c2b45";
var colorBaseBlue900 = "#0b1b23";
var colorBaseOrange50 = "#fff4eb";
var colorBaseOrange75 = "#ffe3cc";
var colorBaseOrange100 = "#ffd3ad";
var colorBaseOrange200 = "#ffb570";
var colorBaseOrange300 = "#ff8404";
var colorBaseOrange400 = "#f76708";
var colorBaseOrange500 = "#ca3e07";
var colorBaseOrange600 = "#9e3105";
var colorBaseOrange700 = "#712304";
var colorBaseOrange800 = "#4f1803";
var colorBaseOrange900 = "#310f02";
var colorBaseYellow50 = "#fff9c0";
var colorBaseYellow75 = "#ffec8f";
var colorBaseYellow100 = "#ffd933";
var colorBaseYellow150 = "#ffc905";
var colorBaseYellow200 = "#ffbc05";
var colorBaseYellow250 = "#faab00";
var colorBaseYellow300 = "#f09800";
var colorBaseYellow350 = "#e58a00";
var colorBaseYellow400 = "#cc7a00";
var colorBaseYellow500 = "#a55f03";
var colorBaseYellow600 = "#824703";
var colorBaseRed50 = "#fdf2f2";
var colorBaseRed75 = "#ffe2df";
var colorBaseRed100 = "#ffd2cc";
var colorBaseRed200 = "#ffa799";
var colorBaseRed300 = "#ff7f6b";
var colorBaseRed400 = "#f55538";
var colorBaseRed500 = "#d42e1c";
var colorBaseRed600 = "#ac1e11";
var colorBaseRed700 = "#79150c";
var colorBaseRed800 = "#530e08";
var colorBaseRed900 = "#380a06";
var colorBaseNeutralAlt50 = "#f3f6fb";
var colorBaseNeutralAlt75 = "#e5e9f0";
var colorBaseNeutralAlt100 = "#d7dce4";
var colorBaseNeutralAlt200 = "#bac0c9";
var colorBaseNeutralAlt300 = "#9fa4ad";
var colorBaseNeutralAlt400 = "#868d95";
var colorBaseNeutralAlt500 = "#697078";
var colorBaseNeutralAlt600 = "#50565e";
var colorBaseNeutralAlt700 = "#383e43";
var colorBaseNeutralAlt800 = "#242a2e";
var colorBaseNeutralAlt900 = "#161a1d";
var colorBaseGreen50 = "#d9fcde";
var colorBaseGreen75 = "#c6f4cc";
var colorBaseGreen100 = "#b1eaba";
var colorBaseGreen200 = "#78d389";
var colorBaseGreen300 = "#3cb95a";
var colorBaseGreen400 = "#00b14f";
var colorBaseGreen500 = "#00804a";
var colorBaseGreen600 = "#03633e";
var colorBaseGreen700 = "#005339";
var colorBaseGreen800 = "#002e27";
var colorBaseGreen900 = "#001e1f";
var colorBrandPrimarySoftest = "#d9fcde";
var colorBrandPrimarySoft = "#b1eaba";
var colorBrandPrimaryDefault = "#00b14f";
var colorBrandPrimaryBold = "#00804a";
var colorBrandPrimaryBoldest = "#005339";
var colorBrandPrimaryTranslucent = "rgba(0, 177, 79, 0.15)";
var colorBrandSecondarySoftest = "#eef9f9";
var colorBrandSecondarySoft = "#b8e5df";
var colorBrandSecondaryDefault = "#2d9f94";
var colorBrandSecondaryBold = "#277c74";
var colorBrandSecondaryBoldest = "#184440";
var colorBackgroundDefault = "#ffffff";
var colorBackgroundAlt = "#f5f5f5";
var colorBackgroundTranslucent = "rgba(255, 255, 255, 0.24)";
var colorBackgroundDefaultInverse = "#1a1a1a";
var colorBackgroundAltInverse = "#3d3d3d";
var colorBackgroundTranslucentInverse = "rgba(26, 26, 26, 0.6)";
var colorBackgroundDisabled = "#f5f5f5";
var colorBackgroundSurfaceLevel1 = "#ffffff";
var colorBackgroundSurfaceLevel2 = "#ffffff";
var colorBackgroundSurfaceLevel3 = "#ffffff";
var colorContentDefault = "#1a1a1a";
var colorContentSubtle = "#3d3d3d";
var colorContentDim = "#707070";
var colorContentPlaceholder = "#a3a3a3";
var colorContentDisabled = "#bfbfbf";
var colorContentDefaultInverse = "#ffffff";
var colorContentTextLinkDefault = "#136fd8";
var colorContentTextLinkBold = "#0b54a8";
var colorContentTextLinkDefaultInverse = "#b3ebff";
var colorContentOnBrandDefault = "#ffffff";
var colorStatusAlertSoftest = "#fdf2f2";
var colorStatusAlertSoft = "#ffd2cc";
var colorStatusAlertDefault = "#d42e1c";
var colorStatusAlertBold = "#ac1e11";
var colorStatusAlertBoldest = "#79150c";
var colorStatusAlertTranslucent = "rgba(212, 46, 28, 0.15)";
var colorStatusInformativeSoftest = "#ebfaff";
var colorStatusInformativeSoft = "#b3ebff";
var colorStatusInformativeDefault = "#136fd8";
var colorStatusInformativeBold = "#0b54a8";
var colorStatusInformativeBoldest = "#0a3d71";
var colorStatusPositiveSoftest = "#d9fcde";
var colorStatusPositiveSoft = "#b1eaba";
var colorStatusPositiveDefault = "#00b14f";
var colorStatusPositiveBold = "#00804a";
var colorStatusPositiveBoldest = "#005339";
var colorStatusPositiveTranslucent = "rgba(0, 177, 79, 0.15)";
var colorStatusNoticeSoftest = "#fff9c0";
var colorStatusNoticeSoft = "#ffd933";
var colorStatusNoticeDefault = "#f09800";
var colorStatusNoticeBold = "#a55f03";
var colorStatusNoticeBoldest = "#824703";
var colorStatusNoticeAltSoftest = "#fff4eb";
var colorStatusNoticeAltSoft = "#ffd3ad";
var colorStatusNoticeAltDefault = "#f76708";
var colorStatusNoticeAltBold = "#ca3e07";
var colorStatusNoticeAltBoldest = "#9e3105";
var colorStatusNeutralContrast = "#ffffff";
var colorStatusNeutralSoftest = "#f5f5f5";
var colorStatusNeutralSoft = "#dbdbdb";
var colorStatusNeutralDefault = "#707070";
var colorStatusNeutralBold = "#575757";
var colorStatusNeutralBoldest = "#3d3d3d";
var colorOutlineSoftest = "#e8e8e8";
var colorOutlineSoft = "#dbdbdb";
var colorOutlineDefault = "#bfbfbf";
var colorOutlineBold = "#a3a3a3";
var colorOutlineBoldest = "#8c8c8c";
var colorOutlineDisabled = "#e8e8e8";

exports.colorBackgroundAlt = colorBackgroundAlt;
exports.colorBackgroundAltInverse = colorBackgroundAltInverse;
exports.colorBackgroundDefault = colorBackgroundDefault;
exports.colorBackgroundDefaultInverse = colorBackgroundDefaultInverse;
exports.colorBackgroundDisabled = colorBackgroundDisabled;
exports.colorBackgroundSurfaceLevel1 = colorBackgroundSurfaceLevel1;
exports.colorBackgroundSurfaceLevel2 = colorBackgroundSurfaceLevel2;
exports.colorBackgroundSurfaceLevel3 = colorBackgroundSurfaceLevel3;
exports.colorBackgroundTranslucent = colorBackgroundTranslucent;
exports.colorBackgroundTranslucentInverse = colorBackgroundTranslucentInverse;
exports.colorBaseBlue100 = colorBaseBlue100;
exports.colorBaseBlue200 = colorBaseBlue200;
exports.colorBaseBlue300 = colorBaseBlue300;
exports.colorBaseBlue400 = colorBaseBlue400;
exports.colorBaseBlue50 = colorBaseBlue50;
exports.colorBaseBlue500 = colorBaseBlue500;
exports.colorBaseBlue600 = colorBaseBlue600;
exports.colorBaseBlue700 = colorBaseBlue700;
exports.colorBaseBlue75 = colorBaseBlue75;
exports.colorBaseBlue800 = colorBaseBlue800;
exports.colorBaseBlue900 = colorBaseBlue900;
exports.colorBaseGreen100 = colorBaseGreen100;
exports.colorBaseGreen200 = colorBaseGreen200;
exports.colorBaseGreen300 = colorBaseGreen300;
exports.colorBaseGreen400 = colorBaseGreen400;
exports.colorBaseGreen50 = colorBaseGreen50;
exports.colorBaseGreen500 = colorBaseGreen500;
exports.colorBaseGreen600 = colorBaseGreen600;
exports.colorBaseGreen700 = colorBaseGreen700;
exports.colorBaseGreen75 = colorBaseGreen75;
exports.colorBaseGreen800 = colorBaseGreen800;
exports.colorBaseGreen900 = colorBaseGreen900;
exports.colorBaseNeutral100 = colorBaseNeutral100;
exports.colorBaseNeutral200 = colorBaseNeutral200;
exports.colorBaseNeutral300 = colorBaseNeutral300;
exports.colorBaseNeutral400 = colorBaseNeutral400;
exports.colorBaseNeutral50 = colorBaseNeutral50;
exports.colorBaseNeutral500 = colorBaseNeutral500;
exports.colorBaseNeutral600 = colorBaseNeutral600;
exports.colorBaseNeutral700 = colorBaseNeutral700;
exports.colorBaseNeutral75 = colorBaseNeutral75;
exports.colorBaseNeutral800 = colorBaseNeutral800;
exports.colorBaseNeutral900 = colorBaseNeutral900;
exports.colorBaseNeutralAlt100 = colorBaseNeutralAlt100;
exports.colorBaseNeutralAlt200 = colorBaseNeutralAlt200;
exports.colorBaseNeutralAlt300 = colorBaseNeutralAlt300;
exports.colorBaseNeutralAlt400 = colorBaseNeutralAlt400;
exports.colorBaseNeutralAlt50 = colorBaseNeutralAlt50;
exports.colorBaseNeutralAlt500 = colorBaseNeutralAlt500;
exports.colorBaseNeutralAlt600 = colorBaseNeutralAlt600;
exports.colorBaseNeutralAlt700 = colorBaseNeutralAlt700;
exports.colorBaseNeutralAlt75 = colorBaseNeutralAlt75;
exports.colorBaseNeutralAlt800 = colorBaseNeutralAlt800;
exports.colorBaseNeutralAlt900 = colorBaseNeutralAlt900;
exports.colorBaseNeutralBlack = colorBaseNeutralBlack;
exports.colorBaseNeutralWhite = colorBaseNeutralWhite;
exports.colorBaseOrange100 = colorBaseOrange100;
exports.colorBaseOrange200 = colorBaseOrange200;
exports.colorBaseOrange300 = colorBaseOrange300;
exports.colorBaseOrange400 = colorBaseOrange400;
exports.colorBaseOrange50 = colorBaseOrange50;
exports.colorBaseOrange500 = colorBaseOrange500;
exports.colorBaseOrange600 = colorBaseOrange600;
exports.colorBaseOrange700 = colorBaseOrange700;
exports.colorBaseOrange75 = colorBaseOrange75;
exports.colorBaseOrange800 = colorBaseOrange800;
exports.colorBaseOrange900 = colorBaseOrange900;
exports.colorBaseRed100 = colorBaseRed100;
exports.colorBaseRed200 = colorBaseRed200;
exports.colorBaseRed300 = colorBaseRed300;
exports.colorBaseRed400 = colorBaseRed400;
exports.colorBaseRed50 = colorBaseRed50;
exports.colorBaseRed500 = colorBaseRed500;
exports.colorBaseRed600 = colorBaseRed600;
exports.colorBaseRed700 = colorBaseRed700;
exports.colorBaseRed75 = colorBaseRed75;
exports.colorBaseRed800 = colorBaseRed800;
exports.colorBaseRed900 = colorBaseRed900;
exports.colorBaseYellow100 = colorBaseYellow100;
exports.colorBaseYellow150 = colorBaseYellow150;
exports.colorBaseYellow200 = colorBaseYellow200;
exports.colorBaseYellow250 = colorBaseYellow250;
exports.colorBaseYellow300 = colorBaseYellow300;
exports.colorBaseYellow350 = colorBaseYellow350;
exports.colorBaseYellow400 = colorBaseYellow400;
exports.colorBaseYellow50 = colorBaseYellow50;
exports.colorBaseYellow500 = colorBaseYellow500;
exports.colorBaseYellow600 = colorBaseYellow600;
exports.colorBaseYellow75 = colorBaseYellow75;
exports.colorBrandPrimaryBold = colorBrandPrimaryBold;
exports.colorBrandPrimaryBoldest = colorBrandPrimaryBoldest;
exports.colorBrandPrimaryDefault = colorBrandPrimaryDefault;
exports.colorBrandPrimarySoft = colorBrandPrimarySoft;
exports.colorBrandPrimarySoftest = colorBrandPrimarySoftest;
exports.colorBrandPrimaryTranslucent = colorBrandPrimaryTranslucent;
exports.colorBrandSecondaryBold = colorBrandSecondaryBold;
exports.colorBrandSecondaryBoldest = colorBrandSecondaryBoldest;
exports.colorBrandSecondaryDefault = colorBrandSecondaryDefault;
exports.colorBrandSecondarySoft = colorBrandSecondarySoft;
exports.colorBrandSecondarySoftest = colorBrandSecondarySoftest;
exports.colorContentDefault = colorContentDefault;
exports.colorContentDefaultInverse = colorContentDefaultInverse;
exports.colorContentDim = colorContentDim;
exports.colorContentDisabled = colorContentDisabled;
exports.colorContentOnBrandDefault = colorContentOnBrandDefault;
exports.colorContentPlaceholder = colorContentPlaceholder;
exports.colorContentSubtle = colorContentSubtle;
exports.colorContentTextLinkBold = colorContentTextLinkBold;
exports.colorContentTextLinkDefault = colorContentTextLinkDefault;
exports.colorContentTextLinkDefaultInverse = colorContentTextLinkDefaultInverse;
exports.colorOutlineBold = colorOutlineBold;
exports.colorOutlineBoldest = colorOutlineBoldest;
exports.colorOutlineDefault = colorOutlineDefault;
exports.colorOutlineDisabled = colorOutlineDisabled;
exports.colorOutlineSoft = colorOutlineSoft;
exports.colorOutlineSoftest = colorOutlineSoftest;
exports.colorStatusAlertBold = colorStatusAlertBold;
exports.colorStatusAlertBoldest = colorStatusAlertBoldest;
exports.colorStatusAlertDefault = colorStatusAlertDefault;
exports.colorStatusAlertSoft = colorStatusAlertSoft;
exports.colorStatusAlertSoftest = colorStatusAlertSoftest;
exports.colorStatusAlertTranslucent = colorStatusAlertTranslucent;
exports.colorStatusInformativeBold = colorStatusInformativeBold;
exports.colorStatusInformativeBoldest = colorStatusInformativeBoldest;
exports.colorStatusInformativeDefault = colorStatusInformativeDefault;
exports.colorStatusInformativeSoft = colorStatusInformativeSoft;
exports.colorStatusInformativeSoftest = colorStatusInformativeSoftest;
exports.colorStatusNeutralBold = colorStatusNeutralBold;
exports.colorStatusNeutralBoldest = colorStatusNeutralBoldest;
exports.colorStatusNeutralContrast = colorStatusNeutralContrast;
exports.colorStatusNeutralDefault = colorStatusNeutralDefault;
exports.colorStatusNeutralSoft = colorStatusNeutralSoft;
exports.colorStatusNeutralSoftest = colorStatusNeutralSoftest;
exports.colorStatusNoticeAltBold = colorStatusNoticeAltBold;
exports.colorStatusNoticeAltBoldest = colorStatusNoticeAltBoldest;
exports.colorStatusNoticeAltDefault = colorStatusNoticeAltDefault;
exports.colorStatusNoticeAltSoft = colorStatusNoticeAltSoft;
exports.colorStatusNoticeAltSoftest = colorStatusNoticeAltSoftest;
exports.colorStatusNoticeBold = colorStatusNoticeBold;
exports.colorStatusNoticeBoldest = colorStatusNoticeBoldest;
exports.colorStatusNoticeDefault = colorStatusNoticeDefault;
exports.colorStatusNoticeSoft = colorStatusNoticeSoft;
exports.colorStatusNoticeSoftest = colorStatusNoticeSoftest;
exports.colorStatusPositiveBold = colorStatusPositiveBold;
exports.colorStatusPositiveBoldest = colorStatusPositiveBoldest;
exports.colorStatusPositiveDefault = colorStatusPositiveDefault;
exports.colorStatusPositiveSoft = colorStatusPositiveSoft;
exports.colorStatusPositiveSoftest = colorStatusPositiveSoftest;
exports.colorStatusPositiveTranslucent = colorStatusPositiveTranslucent;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.js.map